<template>
    <div class="home">
        <Topbar />
        <div class="container-fluid text-left" style="margin-top: 72px; justify-content: center; display: flex">
            <!-- Content Row -->
            <div class="card shadow mb-4 col-md-6 p-0">
                <div class="card-header py-2" :style="{ backgroundColor: moduloAtual().color }">
                    <h6 class="m-0 font-weight-bold text-white small">
                        <span v-if="dados.cliente != null">Cancelamento: {{ id }} - {{ dados.cliente }}</span>
                        <span v-else>Carregando... </span>
                        <div v-show="carregando" class="spinner-grow">
                            <span class="sr-only">Loading...</span>
                        </div>
                    </h6>
                </div>
                <input type="hidden" id="enderecoAtual" v-model="endereco" />
                <fieldset v-if="dados.cliente != null" :disabled="carregando">
                    <div class="card-body bg-light text-primary-dark p-2">
                        <div>
                            <div class="text-center col-auto p-0">
                                <div class="col p-0">
                                    <div class="col p-0 text-left">
                                        <div class="form-row justify-content-sm-between flex-fill px-1 mb-1">
                                            <div class="w-100 text-center">
                                                <span class="text-danger"
                                                    ><b>{{ endereco }}</b></span
                                                >
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col p-0 small">
                                        <InputDefaultApp
                                            inputPlaceHolderSufixo="Digite o produto aqui"
                                            titleScan="Escanear produto"
                                            typeInputMode="text"
                                            @displayScanFunction="onDecode"
                                            @input="() => (errors = [])"
                                            :enterKey="handleInput"
                                            idInput="barras"
                                            autofocus
                                            v-model="barras"
                                            :errorMessage="errors.barras ? errors.barras[0] : ''"
                                        >
                                        </InputDefaultApp>
                                    </div>
                                </div>
                                <div class="form-row mt-2 px-2">
                                    <div class="text-left lh-lg h-auto w-100">
                                        <span class="text-danger font-weight-bold" style="
                                            display: inline-block;
                                            white-space: nowrap;
                                            text-overflow: ellipsis;
                                            overflow: hidden;
                                            width: 100%;"
                                        >{{ dados.item.produto }}</span>
                                        <hr class="my-2">
                                        <b>Produto:</b> [<span class="text-danger">{{ dados.item.codbarras }}</span>]
                                        <br />
                                        <b>Possui Validade:</b> [{{ dados.item.possuivalidade }}]
                                        <br />
                                        <b>Lote / Validade: </b>
                                        <span v-if="dados.item.lote"> [{{ dados.item.lote }}] - </span>
                                        <span v-if="dados.item.validade">
                                            [{{ dateFormat(dados.item.validade) }}]
                                        </span>
                                        <br>
                                        <div style="display: flex; align-items: center; justify-content: space-between;">
                                            <div><b>Quantidade</b> {{ dados.item.qtdecancelamento }} / {{ dados.item.qtde }}</div>
                                        </div>
                                        <div class="mt-2" style="display: flex; align-items: center">
                                            <div style="flex: 1;">
                                                <div
                                                    class="progress lh-lg p-0"
                                                    style="height: 1.8em; display: flex; justify-content: center"
                                                >
                                                    <div
                                                        class=" progress-bar progress-bar-striped progress-bar-animated"
                                                        :style="{ width: barraProgresso, height: '1.8em', marginRight: 'auto' }"
                                                    >
                                                        {{ dados.item.qtdecancelamento_total }} / {{ dados.item.qtde_total }}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="row mt-2 px-2">
                                    <div class="col-lg-12 px-2 table-responsive">
                                        <table class="table-sm">
                                            <thead>
                                                <tr style="white-space: nowrap">
                                                    <th>Próximos Endereços</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr
                                                    v-for="line in proximosEnderecos"
                                                    :key="line"
                                                    :style="{
                                                        backgroundColor: '#' + line.statusbackground,
                                                        color: '#' + line.statuscolor,
                                                    }"
                                                >
                                                    <td>
                                                        <div>
                                                            <div style="display: flex; justify-content: space-between">
                                                                <span class="text-left">{{ line }}</span>
                                                            </div>
                                                        </div>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </fieldset>
            </div>
        </div>
        <ForbiddenModal />
        <LogoutModal />
        <Modal
            id="warningModal"
            title="Aviso"
            :confirmFunction="okWarningModal"
            :cancelFunction="okWarningModal"
            :carregando="carregando"
            confirmText="Ok"
        >
            {{ message }}
        </Modal>
        <Modal
            id="scanModal"
            title="Escanear"
            :carregando="carregando"
            :buttonList="[]"
            :cancelFunction="fecharScan"
        >
            <StreamBarcodeReader v-if="scanAberto" @decode="onDecode" @loaded="onLoaded" @error="onError"></StreamBarcodeReader>
        </Modal>
    </div>
</template>

<script>
// @ is an alias to /src
import Topbar from "@/components/Topbar.vue";
import LogoutModal from "@/components/LogoutModal.vue";
import ViewMixin from "./ViewMixin";
import api, { getEnderecoAtual, getEnderecoOriginal } from "../services/api";
import $ from "jquery";
import {
    ClientErrorException,
    DEFAULT_ERROR_MESSAGE,
    EnderecoDiferenteException,
    ListaConcluidaException,
    PermissaoException,
    ServerErrorException,
    TokenInvalidoException,
    ValidationException,
} from "../services/exceptions";
import { enterKey, dateFormat, selecionar } from "../utils";
import ForbiddenModal from "../components/ForbiddenModal.vue";
import InputDefaultApp from "../components/InputDefaultApp.vue";
import Modal from "../components/Modal.vue";
import { StreamBarcodeReader } from "vue-barcode-reader";
import Audio from "../services/audioService";

export default {
    name: "ProximoItemCancelamento",
    mixins: [ViewMixin],
    components: {
        Topbar,
        LogoutModal,
        ForbiddenModal,
        Modal,
        StreamBarcodeReader,
        InputDefaultApp
    },
    props: ["id"],
    data: () => {
        return {
            idname: "idlista",
            baseUrl: "cancelamento",
            title: {
                icon: "fas fa-cash-register",
                text: "Cancelamento",
            },
            sort: "nome",
            sortDirection: "asc",
            filtro: {
                pesquisa: "",
            },
            arquivoLabel: "Selecionar Arquivo",
            arquivoNome: "",
            arquivos: null,
            endereco: "",
            proximoEndereco: null,
            proximosEnderecos: [],
            scanAberto: false,
            barras: "",
            voltar: false
        };
    },
    mounted() {
        // this.getCombos();
        this.list();
        this.listProximosEnderecos();
        this.endereco = getEnderecoAtual();
    },
    computed: {
        barraProgresso: function() {
            return (this.dados.item.qtdecancelamento_total * 100 / this.dados.item.qtde_total) + "%"
        }
    },
    methods: {
        enterKey,
        dateFormat,

        async list() {
            this.carregando = true;

            try {
                // $("#filtrocard").collapse("hide");

                let endereco = getEnderecoAtual();
                let enderecoOriginal = getEnderecoOriginal();
                let { baseUrl, id } = this;
                let response = await api.get(`/${baseUrl}/proximo-item/${id}`, {
                    params: {
                        endereco,
                        enderecoOriginal,
                    },
                });

                this.dados = response.data;
                this.endereco = endereco

                setTimeout(() => {
                    selecionar('#barras')
                }, 100);
                // this.totalRows = response.data.totalRows;
            } catch (e) {
                this.exception = e;
                if (e instanceof ValidationException) {
                    this.handleValidationException(e);
                } else if (e instanceof TokenInvalidoException) {
                    this.handleTokenInvalidoException();
                } else if (e instanceof PermissaoException) {
                    this.handlePermissaoException();
                } else if (e instanceof ListaConcluidaException) {
                    Audio.success()
                    this.message = e.message;
                    $("#warningModal").modal("show");
                    setTimeout(() => {
                        this.carregando = false;
                    }, 100);
                } else if (e instanceof EnderecoDiferenteException) {
                    this.$router.push('/cancelamento/enderecos/' + this.id)
                } else if (e instanceof ClientErrorException) {
                    this.message = e.message;
                    $("#warningModal").modal("show");
                } else if (e instanceof ServerErrorException) {
                    alert(e.message);
                } else {
                    alert(DEFAULT_ERROR_MESSAGE);
                }
                console.error(e);
            }

            this.carregando = false;
        },

        async listProximosEnderecos() {
            this.carregando = true;

            try {
                // $("#filtrocard").collapse("hide");

                let { sort, sortDirection, filtro, perPage, pular, id } = this;
                let response = await api.get(`/cancelamento/enderecos/${id}`, {
                    params: {
                        sort: `${sort} ${sortDirection}`,
                        ...filtro,
                        perPage,
                        pular,
                    },
                });

                response.data.enderecos.forEach((e, i) => {
                    if (i === 0) {
                        this.proximoEndereco = e;
                    } else {
                        this.proximosEnderecos.push(e);
                    }
                }, this);
            } catch (e) {
                this.exception = e;                
                console.error(e);
            }

            this.carregando = false;
        },

        async bipar() {
            this.carregando = true;

            try {
                let endereco = $("#enderecoAtual").val();
                let barras = $("#barras").val();
                let { baseUrl, id } = this;
                await api.post(`/${baseUrl}/coletar-item/${id}`, { barras, endereco });

                this.errors = []
                this.barras = ""

                await this.list()
            } catch (e) {
                this.exception = e;
                if (e instanceof ValidationException) {
                    this.errors = { barras: [e.errorMessage]};

                    Audio.ops()
                    setTimeout(() => {
                        selecionar('#barras')
                        this.barras = ""
                    }, 100);

                    if (e.errorMessage === "Esta lista já foi concluída!") {
                        this.message = e.errorMessage;
                        $("#warningModal").modal("show");

                        this.voltar = true;
                    }
                } else if (e instanceof TokenInvalidoException) {
                    this.handleTokenInvalidoException();
                } else if (e instanceof PermissaoException) {
                    this.handlePermissaoException();
                } else if (e instanceof ListaConcluidaException) {
                    Audio.success()
                    this.message = e.message;
                    $("#warningModal").modal("show");
                    
                    setTimeout(() => {
                        this.carregando = false;
                    }, 100);
                } else if (e instanceof EnderecoDiferenteException) {
                    this.$router.push('/cancelamento/enderecos/' + this.id)
                } else if (e instanceof ClientErrorException) {
                    this.message = e.message;
                    Audio.ops()
                    $("#warningModal").modal("show");
                } else if (e instanceof ServerErrorException) {
                    alert(e.message);
                } else {
                    alert(DEFAULT_ERROR_MESSAGE);
                }
                console.error(e);
            }

            this.carregando = false;
        },

        okWarningModal() {
            let { exception } = this;
            $("#warningModal").modal("hide");
            if (exception instanceof ListaConcluidaException) {
                Audio.success()
                this.$router.push('/cancelamento')
            }

            if (this.voltar) {
                this.$router.push("/cancelamento");
            }
        },

        handleInput(e) {
            console.log(e)
            this.bipar()
        },

        abrirScan() {
            this.scanAberto = true;
            $("#scanModal").modal("show");
        },
        fecharScan() {
            this.scanAberto = false;
            $("#scanModal").modal("hide");
        },
        onDecode(r) {
            this.barras = r;
            this.fecharScan();
            setTimeout(() => {
                this.handleInput(null);
            }, 100);
        },
        onError(r) {
            console.log(r)
            alert("Não foi possível escanear")
        },
        onLoaded() {
            // $("#scanModal").modal("show");
        },
    },
};
</script>

<style scoped lang="scss">
.spinner-grow {
    width: 1em;
    height: 1em;
}

@media only screen and (min-width: 768px) {
}
</style>
